<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Teslim Cihaz Bilgilerini Güncelle</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" tabindex="0" ngbAutofocus>
    <form [formGroup]="deliveryForm">
        <div class="row">

            <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <label for="company">Durumu</label>
                <div class="form-group">
                    <ng-select [items]="deviceAcceptances" bindLabel="name" bindValue="id"
                        formControlName="deviceAcceptanceStatesId"></ng-select>
                </div>
            </div>

            <div class="form-group col-xl-6 col-md-12 col-sm-12">
                <div class="form-group">
                    <label>Teslim Etme Tarihi</label>
                    <div class="form-group">
                        <ng2-flatpickr [config]="dateTimeStartOptions" [setDate]="date" name="dateTime"
                            formControlName="deliveryDate"></ng2-flatpickr>
                    </div>
                </div>
            </div>

            <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <label for="company">Teslim Şekli</label>
                <div class="form-group">
                    <ng-select [items]="deliveryMethods" bindLabel="deliveryMethodName" bindValue="id"
                        formControlName="deliveryMethodId"></ng-select>

                </div>
            </div>
            
            <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <label for="company">Teslim Alan</label>
                <div class="form-group">
                    <input type="text" id="deliveryPerson" class="form-control" formControlName="deliveryPerson"
                        placeholder="Götüren Kişi" maxlength="50" />
                </div>
            </div>

            <div class="form-group col-xl-12 col-md-12 col-sm-12">
                <label for="personId">Teslim Eden</label>
                <div class="form-group">
                    <ng-select formControlName="personId">
                        <ng-option *ngFor="let user of persons" [value]="user.id">{{user.name + ' '
                            + user.lastName}}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
            <!-- <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <label for="company">Teslim Alan</label>
                <div class="form-group">
                    <ng-select formControlName="deliveryPerson">
                        <ng-option *ngFor="let user of companyPersons" [value]="user.id">{{user.name + ' '
                            + user.lastName}}
                        </ng-option>
                    </ng-select>
                </div>
            </div> -->





            <!-- <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <label for="company">Teslim Durumu</label>
                <div class="form-group">
                    <select formControlName="isDeliveryStatus">
                        <option [value]="true"></option>
                        <option [value]="false"></option>
                    </select>
                </div>
            </div> -->
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()" rippleEffect>İptal</button>
    <button type="button" class="btn btn-success" (click)="onSumbit()" rippleEffect [disabled]="deliveryForm.invalid">Kaydet</button>
</div>